"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lambdaOverrides = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const { AWS_DEFAULT_REGION: region, projectCode, stage, accountId } = process.env;
const queueUrlPrefix = `https://sqs.${region}.amazonaws.com/${accountId}/${projectCode}-${stage}`;
exports.lambdaOverrides = {
    [`${projectCode}-${stage}-EntityState`]: {
        projectFunctionProps: {
            environment: {
                RETRYENABLED: 'true',
                MAXRETRIESENV: '80',
                RETRY_CUSTOMER_NAMES: '',
                APPLY_SQM: iotv_v3_types_1.FEATURE_ON_OFF.ON,
                SQM_QUEUE_URL: `${queueUrlPrefix}-sqmQueue.fifo`,
                EVENT_QUEUE_URL: `${queueUrlPrefix}-eventCreation`,
                PERSIST_THING_SHADOW_STATES: 'false',
                RULE_ENABLED_ENTITY_TYPES: 'FlowMeter,Tank,Dam,EffluentPond,EffluentSump,EffluentTank,EffluentTracker,LateralEffluentSpreader,TravellingEffluentSpreader,PivotEffluentSpreader,SpreadingGun',
            },
        },
        additionalSQSQueueGrants: [
            {
                queueName: 'eventQueue',
                queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-eventCreation`,
            },
            // already a std queue
            // {
            //   queueName: 'sqmQueue',
            //   queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-sqmQueue.fifo`,
            // },
        ],
    },
    // [`${stage}-${projectCode}-device-control-arbitration`]: {
    //   projectFunctionProps: {
    //     environment: {
    //       ALLOW_DUPLICATE_DOWNLINKS: 'true',
    //     },
    //   },
    // },
};
